import { FC, JSX } from "react";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "markdown-toolbar": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & { for: string },
        HTMLElement
      >;
      "md-italic": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-bold": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-quote": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-unordered-list": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-link": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-image": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-ordered-list": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-task-list": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

import { Flex, IconButton } from "@radix-ui/themes";
import {
  FontBoldIcon,
  FontItalicIcon,
  Link1Icon,
  ListBulletIcon,
  PilcrowIcon,
} from "@radix-ui/react-icons";
import "@github/markdown-toolbar-element";

interface MarkdownToolbarProps {
  id: string;
}

const MarkdownToolbar: FC<MarkdownToolbarProps> = ({ id }): JSX.Element => {
  return (
    // @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript
    <markdown-toolbar for={id}>
      <Flex gap="4">
        <Flex gap="1">
          {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
          <md-italic>
            <IconButton variant="soft" highContrast color="gray">
              <FontItalicIcon />
            </IconButton>
            {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
          </md-italic>

          {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
          <md-bold>
            <IconButton variant="soft" highContrast color="gray">
              <FontBoldIcon />
            </IconButton>
            {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
          </md-bold>
        </Flex>

        <Flex gap="1">
          {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
          <md-quote>
            <IconButton variant="soft" highContrast color="gray">
              <PilcrowIcon />
            </IconButton>
            {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
          </md-quote>
          {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
          <md-unordered-list>
            <IconButton variant="soft" highContrast color="gray">
              <ListBulletIcon />
            </IconButton>
            {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
          </md-unordered-list>

          {/* <md-ordered-list>ordered-list</md-ordered-list>
              <md-task-list>task-list</md-task-list> */}
        </Flex>

        <Flex gap="1">
          {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
          <md-link>
            <IconButton variant="soft" highContrast color="gray">
              <Link1Icon />
            </IconButton>
            {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
          </md-link>
        </Flex>
      </Flex>
      {/* @ts-expect-error Custom element "markdown-toolbar" is not recognized by TypeScript */}
    </markdown-toolbar>
  );
};

export default MarkdownToolbar;
